import { useEffect } from 'react';
import { toast } from 'react-toastify';
import {
  authorize,
  getImages,
  getThemeData,
  getThemeVersionConfig,
  getThemeVersions,
  loginStatus,
} from '../functions/API';
import { SessionData, sessionDefault, useSessionStore } from './stores/sessionStore';
import { useScene } from '../context/sceneContext';

export const sessionHooks = () => {
  const scene = useScene();
  const [sessionData, setSessionData] = useSessionStore<SessionData>();

  useEffect(() => {
    // Upsoft account detection
    if (sessionData.isLoaded && sessionData.themeID) {
      if (
        sessionData.email?.endsWith('@upsoft.dev') ||
        sessionData.email === 'bencrow96+test@gmail.com'
      ) {
        setSessionData({ isAuthorized: true });
        toast.info('Upsoft dev account detected. Full functionality enabled.');
      } else if (!sessionData.isAuthorized) {
        toast.error(
          'Access to the launcher theme not authorized. Functionality limited.'
        );
      }
    }
  }, [sessionData.isLoaded]);

  // Gather session data
  useEffect(() => {
    (async () => {
      const params = new URLSearchParams(window.location.search);
      const themeID = params.get('themeId');
      const versionID = params.get('versionId');

      let userData;
      try {
         userData = await loginStatus();
         const { email, paymentModel, planName } = userData;

        let isAuthorized = null;
        if (themeID) {
          try {
            await authorize({ themeID });
            isAuthorized = true;
          } catch {
            isAuthorized = false;
          }
        }

        setSessionData({
          isLoaded: themeID ? false : true,
          isAuthorized,
          email: email || null,
          paymentModel: paymentModel || null,
          planName: planName || null,
          themeID,
          versionID,
        });
      } catch {
        setSessionData({
          ...sessionDefault,
          isLoaded: themeID ? false : true,
          email: userData?.email || null,
          themeID,
          versionID,
        });
      }
    })();
  }, []);

  // Load theme
  useEffect(() => {
    (async () => {
      if (sessionData.themeID) {
        let themeData;
        try {
          themeData = await getThemeData({ themeID: sessionData.themeID });
        } catch {
          toast.error('Error loading theme data');
          setSessionData({
            isLoaded: true,
            themeID: null,
            versionID: null,
          });
        }

        if (!themeData) return;
        const newestVersionId = themeData.newestVersionId;

        if (sessionData.versionID) {
          const config = await getThemeVersionConfig({
            themeID: sessionData.themeID,
            versionID: sessionData.versionID,
          });
          const versions = await getThemeVersions({
            themeID: sessionData.themeID,
          });
          const images = await getImages({ themeID: sessionData.themeID });
          setSessionData({ isLoaded: true, versions, images });
          scene.importConfig(config);
        } else {
          if (newestVersionId) {
            setSessionData({ versionID: newestVersionId });
          } else {
            scene.saveThemeVersion();
            setSessionData({ isLoaded: true });
          }
        }
      }
    })();
  }, [sessionData.themeID, sessionData.versionID]);
};
